import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import ContactForm from './ContactForm';

const contactMethods = [
  { icon: MapPin, label: 'Office', value: '1412 Broadway\nNew York, NY 10018, United States' },
  { icon: Mail, label: 'Email', value: 'office@esinvestmentsmgmt.com' },
  { icon: Phone, label: 'Direct Line', value: 'By request, upon introduction' },
];

function ContactMethod({ icon: Icon, label, value }) {
  return (
    <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
      <div style={{ width: 44, height: 44, background: 'var(--sm-navy)', color: 'var(--sm-ivory)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon size={18} />
      </div>
      <div>
        <div style={{ fontSize: 11, letterSpacing: '0.24em', textTransform: 'uppercase', color: 'var(--sm-gold)', marginBottom: 6 }}>{label}</div>
        <div style={{ fontSize: 15, color: 'var(--sm-navy)', lineHeight: 1.6, whiteSpace: 'pre-line' }}>{value}</div>
      </div>
    </div>
  );
}

export default function ContactSection() {
  return (
    <section id="contact" className="section" style={{ background: 'var(--sm-cream)' }}>
      <div className="container-x">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.2fr', gap: 80 }} className="contact-grid">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
              <span className="hairline" />
              <span className="overline">Get In Touch</span>
            </div>
            <h2 className="serif" style={{ fontSize: 'clamp(34px, 4.2vw, 56px)', lineHeight: 1.08, color: 'var(--sm-navy)', margin: 0 }}>
              Let&rsquo;s start a conversation.
            </h2>
            <p style={{ marginTop: 24, fontSize: 16.5, lineHeight: 1.8, color: 'var(--sm-muted)', maxWidth: 460, textAlign: 'justify' }}>
              For partnership inquiries, sourcing opportunities, or investment discussions, please reach out through the form or the details below.
            </p>

            <div style={{ marginTop: 48, display: 'grid', gap: 24 }}>
              {contactMethods.map((m) => (
                <ContactMethod key={m.label} icon={m.icon} label={m.label} value={m.value} />
              ))}
            </div>
          </div>

          <ContactForm />
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .contact-grid, .form-row { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </section>
  );
}
